import "@babel/polyfill";
import "whatwg-fetch";
import "@zendeskgarden/react-tags/dist/styles.css";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import thunkMiddleware from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import { ConnectedRouter, routerMiddleware } from "connected-react-router";
import errorLogger from "@zendesk/knowledge-redux/lib/middleware/logMiddleware";
import notifyError from "utils/notifyError";
import getQuery from "@zendesk/knowledge-utils/lib/PageNavigator/getQuery";
import setQuery from "@zendesk/knowledge-utils/lib/PageNavigator/setQuery";
import createHistory from "history/createBrowserHistory";
import t from "@zendesk/client-i18n-tools";
import analytics from "@zendesk/knowledge-analytics";
import connect from "@zendesk/knowledge-connect";
import App from "components/App";
import createRootReducer from "./reducers";
import {
  hasEntitlement,
  hasFeature,
  loadContext,
} from "@zendesk/knowledge-context";

const history = createHistory();
const middleware = [
  routerMiddleware(history),
  thunkMiddleware,
  errorLogger(notifyError),
];

if (__DEV__) {
  const { createLogger } = require("redux-logger");
  const logger = createLogger({ collapsed: true });
  middleware.push(logger);
}

const enhancer = applyMiddleware(...middleware);
const store = createStore(createRootReducer(history), undefined, enhancer);

function renderApp(context) {
  t.load(context.token.user.locale, () => {
    document.title = t("knowledge-user-segments.name");

    render(
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <App />
        </ConnectedRouter>
      </Provider>,
      document.getElementById("container")
    );

    setTimeout(() => {
      analytics.setup();
      connect.setup();
    }, 1000);
  });
}

const query = getQuery();

// Make sure a brand with a help center is selected.
// If brand_id in the query is not valid or is not set
// pick the agent brand or a first suitable brand
loadContext({ brandId: query.brand_id }).then(context => {
  if (
    !(hasEntitlement("admin") || hasEntitlement("manager")) ||
    !hasFeature("user_segments")
  ) {
    window.location.replace("/knowledge/lists");
    return;
  }

  const hasBrandId = "brand_id" in query;

  if (!hasBrandId) {
    setQuery({ ...query, brand_id: context.default_brand.id });
  }

  renderApp(context);
});



// WEBPACK FOOTER //
// ./src/index.js